class LoadMoreSwatches extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        var _this = this;
        this.button = this.querySelector('.js-loadmore');
        this.products = this.closest(".swatches-item").querySelector('.swatch-grid-list');
     
        this.totalPages = parseInt(this.dataset.total);
        this.currentPage = parseInt(this.dataset.current);
        this.nextPage = this.dataset.next;
        this.dataset.next = this.nextPage;
        this.swatchFor = this.getAttribute("swatch-for");
        
        this.pageQuery = (new URL(`${window.location.origin}${this.nextPage}`).searchParams).entries();
        this.pageKey = false;
        for (const [key, value] of this.pageQuery) {
            if (key.indexOf("page_") > -1) {
                _this.pageKey = key;
                break;
            }
        }
        this.totalPages > this.currentPage ? this.button.addEventListener('click', this.onButtonClick.bind(this)) : this.classList.add('hidden');
    }

    onButtonClick() {
        console.log(this.button)
        this.nextPage = this.dataset.next;
        this.loadItems(this.nextPage);
    }

    loadItems(nextPage) {
        var _this = this;
        fetch(nextPage, { method: 'GET', headers: { "Content-type": "application/json; charset=UTF-8" } }).then(res => res.text())
            .then((response) => {
                let frag = document.createDocumentFragment(),fetchedContent = document.createElement('div');
                frag.appendChild(fetchedContent);
                fetchedContent.innerHTML = response;
                fetchedContent.innerHTML = fetchedContent.querySelector(`.swatch-grid-list[swatch-list="${this.swatchFor}"]`).innerHTML;
                Array.from(fetchedContent.querySelectorAll(".load-more")).forEach((loadMoreButton)=> loadMoreButton.remove());
                this.button.closest(".load-more").insertAdjacentHTML("beforebegin", fetchedContent.innerHTML)
                this.currentPage = this.currentPage + 1;
                this.dataset.current = this.currentPage;
                 
                this.dataset.next = this.nextPage.replace(`${this.pageKey}=${this.currentPage}`, `${this.pageKey}=${this.currentPage + 1}`);
                this.nextPage = this.dataset.next;
                this.totalPages == this.currentPage ? this.classList.add('hidden') : this.classList.remove('hidden');
                
            });
    }


}

customElements.define('load-more-swatches', LoadMoreSwatches);